// extracted by mini-css-extract-plugin
export default {"loss":"StrategyTrade_loss__cUaEm","profit":"StrategyTrade_profit__eJVE3","root":"StrategyTrade_root__vpUZ-"};